import './TaskPlanModal.scss'
import {
    FooterAction,
    HeaderAction,
    HeaderActionsContainer,
    HeaderTitle,
    HeaderTitleContainer,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader
} from '../../../../../CommonComponents/modals/Modal';
import { useMemo } from 'react'
import useModal from '../../../hooks/useModal';
import useForm from '../../../hooks/useForm';
import { CloseSvg } from '../../../../../CommonComponents/svgs/Svgs';
import { TaskPlanOptionType } from '../../../utils/scenario-types';
import { Form } from 'react-bootstrap';
import { preventEnterKey } from '../../../../../../utils/commonFunctions';
import CustomToolTip from '../../../../../CommonComponents/CustomToolTip';
import useScenarioResponse from '../../../hooks/useScenarioResponse';
import useViewer from '../../../hooks/useViewer';

const TaskPlanModal = () => {
    const { setFormData } = useForm()
    const { modals, setModals } = useModal()
    const { updateGroundPackets } = useViewer()
    const { scenarioResponse } = useScenarioResponse()

    const open = useMemo(() => modals?.configured?.name === 'taskplan', [modals?.configured?.name])
    const taskPlanOptions: TaskPlanOptionType[] = useMemo(() => modals?.configured?.data?.allTaskPlans || [], [modals?.configured?.data?.allTaskPlans])
    const checked: TaskPlanOptionType | null = useMemo(() => modals?.configured?.data?.selectedTaskPlan, [modals?.configured?.data?.selectedTaskPlan])

    const closeModal = () => {
        setModals((prev) => ({
            ...prev,
            configured: null
        }))
    }

    const onSelect = (option: TaskPlanOptionType) => {
        setModals((prev) => ({
            ...prev!,
            configured: {
                ...prev.configured!,
                data: {
                    ...prev.configured?.data!,
                    selectedTaskPlan: prev?.configured?.data?.selectedTaskPlan?.taskPlanId === option?.taskPlanId ? null : option
                }
            }
        }))
    }

    const onSave = () => {
        if (!checked) return
        setFormData((prev) => {
            const filterTaskPlans = prev.schedule.taskplans.filter((taskPlan) => taskPlan.taskPlanId !== checked?.taskPlanId)
            const schedule = {
                ...prev.schedule,
                taskplans: [
                    ...filterTaskPlans,
                    {
                        satelliteGroupId: checked?.satGroupId,
                        taskPlanId: checked?.taskPlanId,
                        taskPlanName: checked?.taskPlanName
                    }
                ]
            }
            // Commented out code for future reference if needed //
            // const status = prev.assets.schedule.data ? validateSameScheduleDetails(schedule, scenarioResponse!) ? 'completed' : 'invalidated' : prev.assets.schedule.status
            const status = prev.assets.schedule.data ? 'invalidated' : prev.assets.schedule.status
            const assets = {
                ...prev.assets,
                schedule: {
                    ...prev.assets.schedule,
                    status: status
                }
            }

            const data = {
                ...prev,
                schedule: schedule,
                assets: assets
            }
            updateGroundPackets(data)
            return data
        })
        closeModal()
    }

    if (!open) return null
    return (
        <Modal open={open} pinned={true} disabled={true} className={`scenario__taskplan__selection__modal`}>
            <ModalHeader className='scenario__taskplan__selection__modal__header'>
                <HeaderTitleContainer>
                    <HeaderTitle>
                        Task Plans
                    </HeaderTitle>
                </HeaderTitleContainer>
                <HeaderActionsContainer>
                    <HeaderAction title='Close' onClick={closeModal}>
                        <CloseSvg />
                    </HeaderAction>
                </HeaderActionsContainer>
            </ModalHeader>
            <ModalBody>
                <div className='scenario__taskplan__selection__modal__body'>
                    {taskPlanOptions.map((option) => {
                        return (
                            <button className='taskplan__list__item__container' key={option?.taskPlanId}
                                onClick={() => onSelect(option)}
                            >
                                <div className='taskplan__list__item__selection__container'>
                                    <Form.Check
                                        type={'radio'}
                                        label=""
                                        className="custom__checkbox__selection"
                                        checked={checked?.taskPlanId === option?.taskPlanId}
                                        onKeyDown={preventEnterKey}
                                    />
                                </div>
                                <div className='taskplan__list__item__details__container'>
                                    <span className='taskplan__list__item__text__container'>
                                        <CustomToolTip title={option?.taskPlanName} placement='top-start'>
                                            {option?.taskPlanName}
                                        </CustomToolTip>
                                    </span>
                                </div>
                            </button>
                        )
                    })}
                </div>
            </ModalBody>
            <ModalFooter>
                <FooterAction variant='outline__button'
                    onClick={closeModal}
                >
                    Cancel
                </FooterAction>
                <FooterAction variant='primary__button'
                    disabled={!checked}
                    onClick={onSave}
                >
                    Save
                </FooterAction>
            </ModalFooter>
        </Modal>
    )
}

export default TaskPlanModal